exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml,body{\n  height:100%;\n}\n.matrix{\n  height:100%;\n  background:#f9f8fd;\n}\np{\n  color:#777777;\n  margin:0;\n}\n.weui-tabbar a{\n  text-decoration: none;\n}\n.weui-tabbar__item.weui-bar__item_on p{\n  margin-top:0;\n}\n", ""]);

// exports
